/**
 * Marks an image as the page's Largest Contentful Paint candidate so the
 * browser fetches it ahead of the rest of the page. LCP is a Core Web Vital and
 * a (small) ranking signal, and a hero image that starts late is the usual
 * reason a content site fails it.
 *
 * Spelled in lowercase and spread rather than passed as the camelCase
 * `fetchPriority` prop: React 18 does not forward that prop to the DOM (it
 * lands in React 19) and warns instead, so the attribute would silently never
 * reach the browser. Swap this for `fetchPriority="high"` on the React 19
 * upgrade.
 */
export const HIGH_FETCH_PRIORITY = { fetchpriority: 'high' } as Record<string, string>;
